export function isEmojiComponent(char: string): boolean {
  const code = char.codePointAt(0);
  if (!code) return false;

  return (
    (code >= 0x1f300 && code <= 0x1faff) ||
    (code >= 0x1f1e6 && code <= 0x1f1ff) ||
    (code >= 0x2600 && code <= 0x26ff) ||
    (code >= 0x2700 && code <= 0x27bf) ||
    (code >= 0x231a && code <= 0x23fa) ||
    (code >= 0x2190 && code <= 0x21ff) ||
    (code >= 0x2934 && code <= 0x2935) ||
    (code >= 0x203c && code <= 0x2049) ||
    (code >= 0x3030 && code <= 0x303d) ||
    code === 0x00a9 ||
    code === 0x00ae ||
    code === 0x2122 ||
    code === 0x24c2 ||
    (code >= 0x1f100 && code <= 0x1f1ff) ||
    (code >= 0x1f200 && code <= 0x1f2ff) ||
    (code >= 0x3200 && code <= 0x32ff) ||
    (code >= 0x25a0 && code <= 0x25ff) ||
    (code >= 0x2b00 && code <= 0x2bff) ||
    (code >= 0x1f3fb && code <= 0x1f3ff) ||
    code === 0x200d ||
    code === 0xfe0f
  );
}
